export default __webpack_public_path__ + "static/media/blank_invoice.468332ad.svg";